function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.9995 4.87119L10.4699 0.40042C10.7816 0.0887121 11.287 0.0886921 11.5987 0.400375C11.9104 0.712059 11.9104 1.21742 11.5987 1.52913L7.12821 5.99998L11.5987 10.4708C11.9104 10.7825 11.9104 11.2879 11.5987 11.5996C11.287 11.9113 10.7816 11.9112 10.4699 11.5995L5.9995 7.12877L1.52929 11.5993C1.21761 11.911 0.71225 11.9111 0.400542 11.5994C0.0888342 11.2877 0.0888141 10.7823 0.400497 10.4706L4.8708 5.99998L0.400497 1.52933C0.0888141 1.21762 0.0888342 0.712259 0.400542 0.400575C0.71225 0.0888921 1.21761 0.0889121 1.52929 0.40062L5.9995 4.87119Z",
  fill: "currentColor"
});

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.5a818f6b.svg";
export { ForwardRef as ReactComponent };